import { useState } from "react";
import styles from './footer.module.css';
import { useNavigate, useLocation } from "react-router-dom";
import { getBackgroundColor, getTextColor } from '../../../code/ColorHandler';
import ContactInformantion from '../Header/ContactInformation';
import SponsoringDisplay from "../Sponsoring/SponsoringDisplay";
function Footer() {
    const [isContactOpen, setIsContactOpen] = useState(false);
    const navigate = useNavigate(); // React Router navigation
    const location = useLocation();
    const HIDDEN_SPONSORING_PATHS = ["/admin", "/service", "/news", "/sponsoren"];
    const isSponsoringHidden = HIDDEN_SPONSORING_PATHS.some(path =>
        location.pathname.startsWith(path)
    );
    return (
        <footer className={styles.footer}>
            <ContactInformantion isContactOpen={isContactOpen} setIsContactOpen={setIsContactOpen} />
            {!isSponsoringHidden && <SponsoringDisplay />}
            <div className={styles.footerDiv} style={{ background: getBackgroundColor(location) }}>
                <div className={styles.center}>
                    <div className={styles.kontakt}>
                        <p tabIndex={0} className={styles.paragraph}
                            onClick={() => navigate("/impressum")}
                            onKeyDown={(e) => {

                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault(); // Prevent space from scrolling
                                    navigate("/impressum")
                                }
                            }}
                            style={{ cursor: "pointer", color: getTextColor(location) }}>Impressum</p>
                        <p tabIndex={0} className={styles.paragraph}
                            onClick={() => navigate("/datenschutz")}
                            onKeyDown={(e) => {

                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault(); // Prevent space from scrolling
                                    navigate("/datenschutz")
                                }
                            }}
                            style={{ cursor: "pointer", color: getTextColor(location) }}>Datenschutz</p>
                        <p tabIndex={0} className={styles.paragraph}
                            onClick={() => setIsContactOpen(true)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault(); // Prevent space from scrolling
                                    setIsContactOpen(true);
                                }
                            }}
                            style={{ cursor: "pointer", color: getTextColor(location) }}>Kontakt</p>
                    </div>
                    <div className={styles.trademark}>
                        <p className={styles.paragraph}
                            style={{ color: getTextColor(location) }}>© 2025 - TuS 05 Oberpleis</p>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;